<template>
  <div v-if="metrics && sceneWidth > 0" class="iso-map-scale" data-map-overlay="scale" role="img" :aria-label="'示意比例尺：' + distance" @pointerdown.stop @pointermove.stop @click.stop @dblclick.stop @wheel.stop>
    <svg :width="barWidth + 28" height="44" :viewBox="`0 0 ${barWidth + 28} 44`" aria-hidden="true">
      <path :d="`M14 27v10M14 32h${barWidth}M${14 + barWidth / 2} 28v8M${14 + barWidth} 27v10`" fill="none" stroke="#365a50" stroke-width="2" />
      <text x="14" y="20">0</text><text data-scene-scale="1" :x="14 + barWidth" y="20" text-anchor="end">{{ distance }}</text>
    </svg>
    <span class="iso-scale-description">示意比例尺，按地图X轴坐标距离换算</span>
  </div>
</template>

<script>
export default {
  name: 'IsometricMapScale',
  props: { metrics: Object, sceneWidth: { type: Number, default: 0 }, zoom: { type: Number, default: 1 } },
  computed: {
    baseWidth () { return this.metrics ? this.metrics.pixels * this.sceneWidth / this.metrics.frameWidth : 0 },
    // Keep the bar legible at small viewport sizes without scaling its UI with the camera.
    barWidth () { return Math.min(180, Math.max(56, this.baseWidth), Math.max(32, this.sceneWidth - 52)) },
    distance () {
      const meters = this.metrics && this.baseWidth > 0 ? this.metrics.meters * this.barWidth / this.baseWidth / Math.max(.1, this.zoom) : 0
      return Number(meters.toPrecision(3)) + ' m'
    }
  }
}
</script>
